import React, { forwardRef } from "react";
import ReactApexChart from "react-apexcharts";

const PieCharts = forwardRef(function ({ series, label }: any, ref: any) {
  const checkValue = (value: number) => value === 0;

  return (
    <>
      <ReactApexChart
        ref={ref}
        options={{
          series: series,

          noData: {
            text: "No Data Found",
          },

          chart: {
            zoom: {
              enabled: false,
            },
          },
          plotOptions: {
            pie: {
              startAngle: 0,
              endAngle: 360,
            },
          },

          tooltip: {
            y: {
              formatter: function (
                value: any,
                { series, seriesIndex, dataPointIndex, w }: any
              ) {
                return `${Math.floor(value / 60)}h: 
                ${value % 60}m`;
              },
            },
          },
          fill: {
            type: "gradient",
          },
          legend: {
            show: false,
            position: "bottom",
          },
          dataLabels: {
            formatter(val, { seriesIndex, w }) {
              return `${Math.floor(series[seriesIndex] / 60)}h: 
              ${series[seriesIndex] % 60}m`;
            },
            // enabled: false,
            style: {
              colors: ["#000000"],
              fontWeight: 400,
            },
          },

          labels: series.every(checkValue) ? [] : label,
          colors: ["#20A2A0", "#ee2560", "#0090FF", "#5d5d5d"],
          responsive: [
            {
              breakpoint: 1300,
              options: {
                chart: {
                  width: 300,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  width: 260,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 300,
                },
              },
            },
          ],
        }}
        // series={[
        //   Math.floor(series?.Ebpower / 3600),
        //   Math.floor(series?.Dgpower / 3600),
        // ]}
        // series={series.map((ele: any) => {
        //   return Math.floor(ele / 60);
        // })}
        series={series?.every(checkValue) ? [] : series}
        type="donut"
      />
    </>
  );
});

export default PieCharts;
